import { ReactNode } from "react";
import { RyeIcon } from "./RyeIcon";
import { RyeTooltip } from "./RyeTooltip";
import { STANDARD_MAIN_CONTENT_CARD_PADDING_X } from "./RyeMainContentContainerBase";
import { buildClasses } from "../utils/buildClasses";

export interface RyeMainContentCardHeaderProps {
  title: string;
  subtitle?: ReactNode;
  onClose?: () => void;
  closeLabel?: string;
}

/** Compact card heading. RyeMainContentCard keeps it above its scroll viewport. */
export function RyeMainContentCardHeader({
  title,
  subtitle,
  onClose,
  closeLabel = "Close pane",
}: RyeMainContentCardHeaderProps): JSX.Element {
  return (
    <div
      className={buildClasses(
        "flex",
        "items-center",
        "gap-4",
        "shrink-0",
        STANDARD_MAIN_CONTENT_CARD_PADDING_X,
        "py-1.5",
      )}
    >
      <div
        className={buildClasses(
          "flex",
          "flex-1",
          "min-w-0",
          "flex-wrap",
          "items-baseline",
          "gap-x-3",
          "gap-y-1",
        )}
      >
        <h3
          className={buildClasses(
            "text-base",
            "font-normal",
            "leading-6",
            "text-on-surface-700",
            "break-words",
            "min-w-0",
          )}
        >
          {title}
        </h3>
        {subtitle != null && (
          <p className={buildClasses("text-sm", "text-on-surface-500")}>
            {subtitle}
          </p>
        )}
      </div>
      {onClose && (
        <RyeTooltip text={closeLabel} placement="top">
          <button
            type="button"
            aria-label={closeLabel}
            onClick={onClose}
            className={buildClasses(
              "shrink-0",
              "h-8",
              "w-8",
              "flex",
              "items-center",
              "justify-center",
              "rounded",
              "text-on-surface-500",
              "hover:bg-surface-200",
              "hover:text-on-surface-800",
              "focus-visible:outline-none",
              "focus-visible:ring-2",
              "focus-visible:ring-purple",
            )}
          >
            <span aria-hidden="true">
              <RyeIcon name="close" size="md" />
            </span>
          </button>
        </RyeTooltip>
      )}
    </div>
  );
}
